import StartMobile from "@/components/module/influencer/StartMobile";
import SignUpSomnium from "@/components/module/influencer/StartMobile";
import LoginMobile from "@/components/module/influencer/LoginMobile";
import CreatorDashboardMobile from "@/components/module/influencer/CreatorDashboardMobile";
import CreateAccountMobile from "@/components/module/influencer/CreateAccountMobile";
import SetPriceMobile from "@/components/module/influencer/payment/SetPriceMobile";
import YourLinkMobile from "@/components/module/influencer/YourLinkMobile";
import FriendMenuMobile from "@/components/module/influencer/FriendMenuMobile";
import BlockedFriendsMobile from "@/components/module/influencer/BlockedFriendsMobile";
import BonusContentAdd from "@/components/module/influencer/content/BonusContentAdd";
import BonusContentList from "@/components/module/influencer/content/BonusContentList";
import BonusContentEdit from "@/components/module/influencer/content/BonusContentEdit";
import DisabledAccount from "@/components/module/shared/DisabledAccount";
import Platforms from "../../../components/module/influencer/Platforms";
import CreatorMessageDashboard from "@/components/module/influencer/direct-message/CreatorMessageDashboard";
import CreatorDirectMessage from "@/components/module/influencer/direct-message/CreatorDirectMessage";
import Announcement from "@/components/module/influencer/direct-message/Announcement";
//Load these lazily /* webpackChunkName: "influencer" */
const HelpMobile = () => import(/* webpackChunkName: "influencer" */ "@/components/module/shared/HelpMobile");
// const FAQ = () => import(/* webpackChunkName: "influencer" */ "@/components/module/influencer/FAQ");
const RecentTransactionMobile = () => import(/* webpackChunkName: "influencer" */ "@/components/module/influencer/payment/RecentTransactionMobile");
// const TermsOfService = () => import(/* webpackChunkName: "influencer" */ "@/components/module/shared/TermsOfService");
const PrivacyPolicy = () => import(/* webpackChunkName: "influencer" */ "@/components/module/shared/PrivacyPolicy");
const BillingMobile = () => import(/* webpackChunkName: "influencer" */ "@/components/module/influencer/payment/BillingMobile");
const SettingsMobile = () => import(/* webpackChunkName: "influencer" */ "@/components/module/influencer/SettingsMobile");
const CustomRequestList = () => import(/* webpackChunkName: "influencer" */ "@/components/module/influencer/custom-request/CustomRequestList");
const CustomRequestOptionList = () => import(/* webpackChunkName: "influencer" */ "@/components/module/influencer/custom-request/CustomRequestOptionList");
const CustomRequestOptionCreate = () => import(/* webpackChunkName: "influencer" */ "@/components/module/influencer/custom-request/CustomRequestOptionCreate");
/* new routes for home page routes */
const HomePage = () => import(/* webpackChunkName: "front" */ "@/components/module/front/HomePage");
const TopCreators = () => import(/* webpackChunkName: "front" */ "@/components/module/front/TopCreators");
const AboutPage = () => import(/* webpackChunkName: "front" */ "@/components/module/front/AboutPage");
const FAQ = () => import(/* webpackChunkName: "influencer" */ "@/components/module/front/FAQ");
const TermsOfService = () => import(/* webpackChunkName: "influencer" */ "@/components/module/front/TermsOfService");
/* new routes for home page routes */

export const routes = [
  { path: '/about-us', alias: '/about-us/in', name: 'AboutPage', component: AboutPage },
  {
    path: '/blog',
    alias: '/blog-list/in',
    name: 'BlogList',
    beforeEnter() {
      window.location.href = 'https://blog.stella.so';
    }
  },
  {
    path: '/blog/:id',
    alias: '/blog-details/in',
    name: 'BlogDetails',
    beforeEnter() {
      window.location.href = 'https://blog.stella.so';
    }
  },

  // {path: '/:urlPrefix?', name: 'StartMobile', component: StartMobile},
  { path: '/account/disabled', alias: '/disabledAccount/in', name: 'DisabledAccount', component: DisabledAccount },
  { path: '/a/:agencyName', name: 'SignUpSomnium', component: SignUpSomnium },

  { path: '/login/:urlPrefix?', alias: '/loginMobile/in/:urlPrefix?', name: 'LoginMobile', component: LoginMobile },
  { path: '/creator/dashboard', alias: '/creatorDashboardMobile/in', name: 'CreatorDashboardMobile', component: CreatorDashboardMobile },
  { path: '/creator/register', alias: '/createAccountMobile/in', name: 'CreateAccountMobile', component: CreateAccountMobile },
  { path: '/creator/set-price', alias: '/setPriceMobile/in', name: 'SetPriceMobile', component: SetPriceMobile },
  { path: '/creator/your-link', alias: '/yourLinkMobile/in', name: 'YourLinkMobile', component: YourLinkMobile },
  { path: '/creator/friends', alias: '/friendMenuMobile/in', name: 'FriendMenuMobile', component: CreatorDashboardMobile },
  { path: '/creator/friends/blocked', alias: '/blockedFriendsMobile/in', name: 'BlockedFriendsMobile', component: BlockedFriendsMobile },
  { path: '/creator/billing', alias: '/billingMobile/in', name: 'BillingMobile', component: BillingMobile },
  { path: '/creator/transactions', alias: '/recentTransactionMobile/in', name: 'RecentTransactionMobile', component: RecentTransactionMobile },
  { path: '/creator/settings', alias: '/settingsMobile/in', name: 'SettingsMobile', component: SettingsMobile },

  { path: '/help', alias: '/helpMobile/in', name: 'HelpMobile', component: HelpMobile },
  { path: '/terms', alias: '/termsOfService/in', name: 'TermsOfService', component: TermsOfService },
  { path: '/privacy', alias: '/privacyPolicy/in', name: 'PrivacyPolicy', component: PrivacyPolicy },
  { path: '/faq', alias: '/faq/in', name: 'FAQ', component: FAQ },

  { path: '/creator/bonus-content/add', alias: '/bonusContentAdd/in', name: 'BonusContentAdd', component: BonusContentAdd },
  { path: '/creator/bonus-content/:contentId/edit', alias: '/bonusContentEdit/in/:contentId', name: 'BonusContentEdit', component: BonusContentEdit },
  { path: '/creator/bonus-content', alias: '/bonusContentList/in', name: 'BonusContentList', component: BonusContentList },

  { path: '/creator/custom-requests', alias: '/customRequestList/in', name: 'CustomRequestList', component: CustomRequestList },
  { path: '/creator/custom-requests/options', alias: '/customRequestOptionList/in', name: 'CustomRequestOptionList', component: CustomRequestOptionList },
  { path: '/creator/custom-requests/options/create/:customRequestOptionId?', alias: '/customRequestOptionCreate/in/:customRequestOptionId?', name: 'CustomRequestOptionCreate', component: CustomRequestOptionCreate },
  { path: '/creator/platforms', alias: '/platforms/in', name: 'Platforms', component: Platforms },

  { path: '/creator/messages/dashboard', alias: ['/creatorMessageDashboard/in', '/creator/messages', '/MessageDashboard/in'], name: 'CreatorMessageDashboard', component: CreatorMessageDashboard },
  { path: '/creator/messages/direct/:customerId?', alias: ['/creatorDirectMessage/in/:customerId?', '/DirectMessage/in', '/creator/messages/direct'], name: 'CreatorDirectMessage', component: CreatorDirectMessage },
  { path: '/creator/announcements', alias: ['/announcement/in', '/creator/announcement'], name: 'Announcement', component: Announcement },

  // Catch-all single segment routes (e.g. /influencerUsername)
  { path: '/top-creators', name: 'TopCreators', component: TopCreators },
  { path: '/:urlPrefix?', name: 'HomePage', component: HomePage },
]
